import { render } from "./Work.vue?vue&type=template&id=10cf05a6&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=10cf05a6&scoped=true&lang=css"
import "./Work.vue?vue&type=style&index=1&id=10cf05a6&global=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cf05a6"]])

export default __exports__